<template>
    <v-textarea :maxlength="maxlength" v-model="textarea" :clearable ="clearable" :auto-grow="autGrow" :clear-icon="clearIcon" :label="label" :rules="rules" counter :rows="rows" :row-height="rowHeight" :color="color" :outlined="outlined" :readonly="readolny" :disabled="disabled"  dense></v-textarea>
    <!--<v-textarea :maxlength="maxlength" v-model="textarea" clearable auto-grow :clear-icon="clearIcon" :label="label" :rules="rules" counter :rows="rows" :row-height="rowHeight" :color="color" :outlined="outlined" :disabled="disabled" dense></v-textarea>-->
</template>

<script>
export default {
  name: "RyouTextarea",
  props: {
    label: {
      type: String,
      required: false,
      default: ""
    },
    value: {
      type: String,
      required: false,
      default: ""
    },
    clearIcon: {
      type: String,
      required: false,
      default: "mdi-close-circle"
    },
    maxlength: {
      type: Number,
      required: false
    },
    rows: {
      type: Number,
      required: false,
      default: 3
    },
    rowHeight: {
      type: Number,
      required: false,
      default: 30
    },
    counter: {
      type: String,
      required: false,
      default: ""
    },
    color: {
      type: String,
      required: false,
      default: ""
    },
    rules: {
      type: Array,
      required: false,
      default: () => []
    },
    outlined: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
      },
      clearable: {
          type: Boolean,
          required: false,
          default: true
      },
      autGrow: {
          type: Boolean,
          required: false,
          default: true
      },
      readolny: {
          type: Boolean,
          required: false,
          default: false
      }
  },
  data() {
    return {};
  },
  methods: {},
  computed: {
    textarea: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>

<style scoped>
</style>
